import Markdown from "@/components/Markdown";
import { parseCarousel } from "@/lib/carousel";

// Renders a `carrossel` artifact as numbered card blocks + highlighted caption
// (Epic 16.2). Falls back to plain markdown whenever the content doesn't parse
// into at least 2 cards.
export default function CarouselArtifact({ content }) {
  const parsed = parseCarousel(content);
  if (!parsed) return <Markdown text={content} />;
  return (
    <div className="space-y-3" data-testid="carousel-artifact">
      {parsed.cards.map((c) => (
        <div
          key={c.n}
          data-testid={`carousel-card-${c.n}`}
          className="bg-brand-elevated border border-brand-line rounded-2xl p-4"
        >
          <div className="flex items-center gap-2.5 mb-2">
            <span className="shrink-0 px-2.5 py-1 rounded-full bg-brand-rose/15 text-brand-rose text-[10.5px] tracking-[0.16em] uppercase font-ui">
              Card {c.n}
            </span>
            {c.title && (
              <span className="font-display text-[16px] text-brand-ink leading-tight">
                {c.title}
              </span>
            )}
          </div>
          <Markdown text={c.body} />
        </div>
      ))}
      {parsed.legenda && (
        <div
          data-testid="carousel-legenda"
          className="bg-brand-surface border border-brand-rose/40 rounded-2xl p-4"
        >
          <div className="text-[10.5px] tracking-[0.2em] uppercase text-brand-rose font-ui mb-2">
            Legenda
          </div>
          <Markdown text={parsed.legenda} />
        </div>
      )}
    </div>
  );
}
